import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

useAccount.propTypes = {};

function useAccount(props) {
  const { user } = useSelector((state) => state.auth);
  const saleCommissionList = user?.agency?.saleCommission;

  return useMemo(() => {
    return {
      getCurrentSaleCommission: (revenue) => {
        const ret = _.find(saleCommissionList, (item) => item.revenue > revenue);
        return ret;
      },
    };
  }, [user]);
}

export default useAccount;
